import { Button, Divider, Box } from '@mui/material';

interface FooterButtonProps {
  buttonText: string;
  onClick?: () => void;
}

export const FooterButton = ({ buttonText, onClick }: FooterButtonProps) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Divider />
      <Box
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <Button
          onClick={onClick}
          sx={{ margin: 1 }}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};
